import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils';
import UpsellBannerIllustration from 'lumen/assets/images/upsell/performance-upsell-banner.svg?raw';
import type HotelBiUpsellController from 'lumen/controllers/hotel/bi-upsell';

import styles from './bi-upsell.module.css';

interface HotelBiUpsellSignature {
  Args: {
    controller: HotelBiUpsellController;
    model: unknown;
  };
}

const LEARN_MORE_URL = 'https://www.mylighthouse.com/platform/performance';

const HotelBiUpsell = <template>
  <div class="h-full">
    <div class={{styles.background}} />

    <div class="{{styles.banner}} {{styles.content}} h-[360px]">
      <div class="{{styles.info}} flex flex-row justify-center gap-1000">
        <h1 class={{styles.title}}>
          {{#if @controller.hotelHasRequestedContact}}
            <p class="request-sent">
              {{t "upsell.bi.request_sent"}}
            </p>
          {{else}}
            {{t "upsell.bi.dialog_info_title"}}
          {{/if}}
        </h1>

        <div class="paragraph-300--regular w-[300px]">
          <div class="flex flex-col gap-400">
            {{#if @controller.hotelHasRequestedContact}}
              <span>
                {{t "upsell.bi.banner.trial.content.trial_requested"}}
              </span>
            {{else}}
              {{#each @controller.benefits as |benefit|}}
                <p class="flex flex-row">
                  <PrismIcon @name="checkmark" @size="small" />
                  <span class="ml-200">
                    {{t benefit}}
                  </span>
                </p>
              {{/each}}
            {{/if}}
          </div>

          <div class="mt-400">
            {{#if @controller.hotelHasRequestedContact}}
              <a
                class="prism-button prism-button--brand w-full"
                data-test-id="bi-upsell-learn-more-button"
                href={{LEARN_MORE_URL}}
                rel="noopener noreferrer"
                target="_blank"
              >
                {{t "general.learn_more"}}
              </a>
            {{else}}
              <PrismButton
                @buttonType="brand"
                @iconAfter="arrow-right"
                @isDisabled={{@controller.isLoading}}
                @isLoading={{@controller.isLoading}}
                @label={{t "general.get_in_touch"}}
                @onClick={{@controller.sendGetInTouch}}
                class="w-full"
                data-test-id="bi-upsell-get-in-touch-button"
              />

              <a
                class="prism-button prism-button--secondary mt-200 w-full"
                data-test-id="bi-upsell-learn-more-button"
                href={{LEARN_MORE_URL}}
                rel="noopener noreferrer"
                target="_blank"
              >
                {{t "general.learn_more"}}
              </a>
            {{/if}}
          </div>
        </div>
      </div>

      <div class={{styles.image}}>
        <Illustration @html={{UpsellBannerIllustration}} />
      </div>
    </div>
  </div>
</template> satisfies TOC<HotelBiUpsellSignature>;

export default HotelBiUpsell;
